import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesOrderItem, SalesOrderItemCreate, SalesOrderItemFilter } from '../data/salesOrderItem';

export function createSalesOrderItemService(client: AxiosInstance) {
  return createCrudService<SalesOrderItem, SalesOrderItemCreate, SalesOrderItemFilter>(
    client,
    '/SalesOrderItem',
    'salesOrderItemId'
  );
}

export type SalesOrderItemService = CrudService<
  SalesOrderItem,
  SalesOrderItemCreate,
  SalesOrderItemFilter
>;
